import {makeStyles} from '@material-ui/core';
const useStyles = makeStyles((theme) => {
  return {
    container: {
      maxHeight: '100vh',
      paddingLeft: 30,
      paddingTop: 30,
      paddingBottom: 30,
      width: '16rem',
      [theme.breakpoints.up('xl')]: {
        width:  '22.8rem',
      },
    },
    drawerContainer: {
      boxShadow:'-2px 0px 8px 3px rgba(51,51,51,0.2)',
      zIndex: 99,
      maxHeight: '100vh',
      paddingLeft: "0 !important",
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
      position:"fixed",
      width: '16rem'
    },
    sidebarBg: {
      overflow: 'hidden',
      backgroundColor:theme.palette.primary.main,
    },
    scrollAppSidebar: {
      paddingBottom: 25,
      backgroundColor:theme.palette.primary.main,
      height: '100vh !important',
      [theme.breakpoints.up('xl')]: {
        height: 'calc(100vh - 110px) !important' ,
      },
    },
    drawerScrollAppSidebar: {
      paddingBottom: 25,
      height: '100vh !important',
    },

    sidebarModern: {
      height: '100%',
      width: '100%',
      color: 'white',
      overflow: 'hidden',
      borderRadius: 30,
    },
    sidebarStandard: {
      height: '100%',
      width: '100%',
      color: 'white',
      overflow: 'hidden',
    },
  };
});
export default useStyles;
